import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-671d2912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ph" }
const _hoisted_2 = { class: "ph__elm" }
const _hoisted_3 = { class: "ph__elm-row-icon" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "ph__elm-row-message" }
const _hoisted_8 = { class: "ph__elm-row-message_text" }
const _hoisted_9 = { class: "ph__elm-row-cost" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { class: "ph__elm-row-period" }
const _hoisted_13 = { class: "ph__elm-row-period-active" }
const _hoisted_14 = { class: "ph__elm-row-period-month" }
const _hoisted_15 = { class: "ph__elm-row-period-m" }
const _hoisted_16 = { class: "ph__elm-row-period-m-month" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconPlus = _resolveComponent("IconPlus")!
  const _component_IconArrowLeftDown = _resolveComponent("IconArrowLeftDown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payHistory, (item, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "ph__elm-row",
          key: idx
        }, [
          _createElementVNode("div", _hoisted_3, [
            (item.type === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_IconPlus)
                ]))
              : _createCommentVNode("", true),
            (item.type === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_IconArrowLeftDown)
                ]))
              : _createCommentVNode("", true),
            (item.type === 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_IconPlus)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (item.type === 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", null, _toDisplayString(0 < item.cost
										? "Пополнение баланса"
										: "Списание с баланса"), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.amount * item.cost) + " ₽ ", 1)
                  ], 64))
                : (item.type === 1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(item.amount) + " " + _toDisplayString(_ctx.declOfNum(item.amount)), 1))
                  : (item.type === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, "Покупка опций"))
                    : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, _toDisplayString(0 < item.cost ? "Дата покупки" : "Дата списания"), 1),
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.dataTimeFormat(item.paidStamp)), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.dataTimeFormat(item.paidStamp)), 1)
          ])
        ]))
      }), 128))
    ])
  ]))
}